<div class="content-landing">
    <!-- Element 1: Introduction -->
    <div class="row elem elA">
        <div class="col-6 ">
            <img [src]="img2" class="elem-image" [alt]="'img2'">
        </div>
        <div class="col-6 elem-info ms-3">
            <div class="elem-head">
                <h2 class="" [innerHTML]="translationCode['landing.heading']"></h2>
            </div>
            <div class="elem-content">
                <p [innerHTML]="translationCode['landing.content']">
                </p>
                <div class="cta-container" *ngIf="!isSession">
                    <space-btn class="btn_login" aria_label='btn_login' id_btn='btn_login' disabled='false' variant='btn1' label='Login' [routerLink]="['/login']" [attr.data-event]="GTM_EVENTS.LANDING_LOGIN">
                        Login
                    </space-btn>
                </div>
            </div>
        </div>
    </div>
    <!-- Element 1: Features -->
    <div class="row elem elB">
        <div class="col-6 elem-info ms-3">
            <div class="elem-head">
                <h2 class="elem-head-second-h2" [innerHTML]="translationCode['landing.features']"></h2>
            </div>
            <div class="elem-content">
                <p class="header" [innerHTML]="translationCode['landing.features.heading']">

                </p>
                <ul class="feature-checklist">
                    <li class="feature-item">
                        <img [src]="'green-check' | asset" class="check-icon me-2" [alt]="'green-check'"/>
                        <span [innerHTML]="translationCode['landing.feature1']"></span>
                    </li>
                    <li class="feature-item">
                        <img [src]="'green-check' | asset" class="check-icon me-2" [alt]="'green-check'"/>
                        <span [innerHTML]="translationCode['landing.feature2']"></span>
                    </li>
                    <li class="feature-item">
                        <img [src]="'green-check' | asset" class="check-icon me-2" [alt]="'green-check'"/>
                        <span [innerHTML]="translationCode['landing.feature3']"></span>
                    </li>
                    <li class="feature-item">
                        <img [src]="'green-check' | asset" class="check-icon me-2" [alt]="'green-check'"/>
                        <span [innerHTML]="translationCode['landing.feature4']"></span></li>
                    <li class="feature-item">
                        <img [src]="'green-check' | asset" class="check-icon me-2" [alt]="'green-check'"/>
                        <span [innerHTML]="translationCode['landing.feature5']"></span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-6 ">
            <img [src]="img1" class="elem-image-second" [alt]="'img1'">
        </div>
    </div>
    <!-- Element 1: Benefits -->
    <div class="row elem elB">
        <div class="col-12 elem-info">
            <div class="elem-head">
                <h2 class="" [innerHTML]="translationCode['landing.subHeading']">​</h2>
            </div>
            <div class="elem-content" >
                <p [innerHTML]="translationCode['landing.subMessage']"></p>
                <div class="row fleet-benefits">
                    <div class="col-md-4 benefit">
                        <div class="row">
                            <div class="col-1 benefit-img">
                                <space-icon icon='remotecontrol' outline='true'></space-icon>
                            </div>
                            <div class="col-11 benefit-content">
                                <p class="head-txt" [innerHTML]="translationCode['landing.subfeature1.heading']"></p>
                                <p class="c-txt" [innerHTML]="translationCode['landing.subfeature1.content']">
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 benefit">
                        <div class="row">
                            <div class="col-1 benefit-img">
                                <space-icon icon='mobile' outline='true'></space-icon>
                            </div>
                            <div class="col-11 benefit-content">
                                <p class="head-txt" [innerHTML]="translationCode['landing.subfeature2.heading']"></p>
                                <p class="c-txt" [innerHTML]="translationCode['landing.subfeature2.content']"></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 benefit">
                        <div class="row">
                            <div class="col-1 benefit-img">
                                <space-icon icon='list' outline='true'></space-icon>
                            </div>
                            <div class="col-11 benefit-content">
                                <p class="head-txt" [innerHTML]="translationCode['landing.subfeature3.heading']"></p>
                                <p class="c-txt" [innerHTML]="translationCode['landing.subfeature3.content']"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
